import { DialogBackdrop, DialogPanel } from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/24/solid";
import { useDispatch } from "react-redux";
import { addToCart } from "../../features/cart/cartSlice";
import { toast } from "react-toastify";
import { shoppingSvg } from "../../assets/images";

function DetailProduct({ item, stateModal }) {
  const dispatch = useDispatch();

  const handleAddToCart = () => {
    if (item.stock_quantity > 0) {
      dispatch(
        addToCart({
          ...item,
          price: Number(item.price),
          quantity: Number(item.stock_quantity),
        })
      );
      toast.success(`✓ ${item.name} a été ajouté au panier!`);
    } else {
      toast.warning("Ce produit n'est pas disponible en stock");
    }
  };

  return (
    <>
      <DialogBackdrop
        transition
        className="fixed inset-0 hidden bg-gray-500 bg-opacity-75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in md:block"
      />

      <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
        <div className="flex min-h-full items-stretch justify-center text-center md:items-center md:px-2 lg:px-4">
          <DialogPanel
            transition
            className="flex w-full transform text-left text-base  transition data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in md:my-8 md:max-w-2xl md:px-4 data-[closed]:md:translate-y-0 data-[closed]:md:scale-95 lg:max-w-6xl "
          >
            <div className="relative grid grid-cols-1 md:grid-cols-3 w-full md:h-[60vh] items-start md:items-center overflow-y-auto bg-white px-4 pb-8 pt-14 shadow-2xl sm:px-6 sm:pt-8 md:p-6 lg:p-8 ">
              <button
                type="button"
                onClick={() => stateModal(false)}
                className="absolute right-3 top-3 text-gray-400 hover:text-gray-500"
              >
                <span className="sr-only">Close</span>
                <XMarkIcon aria-hidden="true" className="h-6 w-6" />
              </button>
              <span className="mx-auto py-auto  w-full ">
                <img
                  src={
                    item.image
                      ? `${process.env.REACT_APP_BACK_URL}${item.image}`
                      : shoppingSvg
                  }
                  alt={item.title}
                  className="relative inline-block h-[50vh] object-contain object-center"
                />
              </span>
              <div className="col-span-2 flex flex-col justify-center mx-auto gap-8 h-full">
                <p className="text-2xl font-semibold text-gray-900">
                  {/* {truncateText(item.name, 20)} */}
                  {item.name}
                </p>
                <p className="text-lg text-gray-700">
                  {/* {truncateText(item.description, 100)} */}
                  {item.description}
                </p>
                <p className="text-lg font-medium text-black">
                  Quantité disponible:{" "}
                  <span className="text-green-600 font-bold">
                    {item.stock_quantity} unité(s)
                  </span>
                </p>
                <p className="text-2xl font-bold text-primary">
                  Prix: {item.price} XOF
                </p>
                <button
                  disabled={item.stock_quantity <= 0}
                  className="py-3 px-4 bg-black text-white rounded hover:bg-gray-800 disabled:bg-gray-400 disabled:cursor-not-allowed transition duration-150 w-full flex items-center justify-center"
                  onClick={handleAddToCart}
                  aria-label={item.stock_quantity > 0 ? "Ajouter au panier" : "Ce produit n'est pas disponible"}
                >
                  {item.stock_quantity > 0 ? "Ajouter au panier" : "Rupture de stock"}
                  {item.stock_quantity > 0 && (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-6 w-6 ml-2"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z"
                      />
                    </svg>
                  )}
                </button>

                <button
                  className="sm:hidden py-3 px-4 bg-gray-500 text-white rounded hover:bg-blue-600 active:bg-gray-700 disabled:opacity-50 w-full flex items-center justify-center"
                  onClick={() => stateModal(false)}
                >
                  Annuler
                </button>
              </div>
            </div>
          </DialogPanel>
        </div>
      </div>
    </>
  );
}

export default DetailProduct;
